import { RoleLiteModel } from 'api-hooks/role';
import { Expose, Type } from 'class-transformer';
import { EmployeeJobLevelEnum } from 'common/constants/enum';
import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

export class EmployeePromotionModel {
  id: string;

  @Expose({ name: 'job_level' })
  jobLevel: EmployeeJobLevelEnum;

  @Expose({ name: 'promoted_at' })
  @Type(() => Date)
  promotedAt: Date;
}

// Model
export class EmployeeSimpleModel extends CommonModel {
  name: string;
  // email: string;
  username: string;
  phone: string;
  phone_2?: string;
  address?: string;
}

export class EmployeeLiteModel extends EmployeeSimpleModel {
  @Expose({ name: 'joined_at' })
  @Type(() => Date)
  joinedAt: Date | null;

  @Expose({ name: 'job_level' })
  jobLevel: EmployeeJobLevelEnum | null;

  @Type(() => RoleLiteModel)
  roles: RoleLiteModel[];
}

export class EmployeeModel extends EmployeeLiteModel {
  code: string;
  gender: string;

  @Type(() => Number)
  commission: number;

  @Expose({ name: 'commission_type' })
  commissionType: string;

  @Type(() => EmployeePromotionModel)
  promotions: EmployeePromotionModel[];
}

// Input

export type getEmployeesInput = {
  params: CommonParamInput;
};

export type getEmployeeInput = {
  id: string;
};

export type EmployeeMutationInput = {
  name: string;
  email: string;
  password?: string;
  passwordConfirmation?: string;
  code: string;
  gender: string | null;
  phone: string;
  phone_2?: string;
  address: string;
  commission: number;
  commissionType: string | null;
  roles: string[];
};

export type EmployeePromotionMutationInput = {
  jobLevel: string;
  promotedAt: Date;
};

export type EmployeePromotionUpdateMutationInput = {
  id: string;
  body: EmployeePromotionMutationInput;
};

export type EmployeePromotionDeleteMutationInput = {
  id: string;
};

export type EmployeeUpdateInput = {
  employeeId: string;
  body: EmployeeMutationInput;
};

export type EmployeeDeleteInput = {
  employeeId: string;
};

export type EmployeeChangePasswordInput = {
  oldPassword: string;
  password: string;
  passwordConfirmation: string;
};
